export enum ZoomRoles {
  PARTICIPANT = 0,
  HOST = 1,
}
